import { render, staticRenderFns } from "./LotAnnexItem.vue?vue&type=template&id=f5a49efc&"
import script from "./LotAnnexItem.vue?vue&type=script&lang=js&"
export * from "./LotAnnexItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports